import { FC } from "react";

import { ParcImmobilierMinimalDto } from "api/real-estate";
import { ParcCard } from "./ParcCard";
import { RealEstateEmptyState } from "./RealEstateEmptyState";

interface ParcGridProps {
  parcs: ParcImmobilierMinimalDto[];
  selectedParcId: string;
  isLoading: boolean;
  onSelect: (id: string) => void;
  emptyStateProps: {
    title: string;
    description: string;
    actionLabel: string;
    onAction: () => void;
  };
}

const SKELETON_COUNT = 3;

export const ParcGrid: FC<ParcGridProps> = ({
  parcs,
  selectedParcId,
  isLoading,
  onSelect,
  emptyStateProps
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
          <div key={`skeleton-${index}`} className="h-40 rounded-xl border bg-gray-50 animate-pulse" />
        ))}
      </div>
    );
  }

  if (parcs.length === 0) {
    return <RealEstateEmptyState {...emptyStateProps} />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {parcs.map((parc) => (
        <ParcCard
          key={parc.id}
          parc={parc}
          isSelected={selectedParcId === parc.id}
          onSelect={() => onSelect(parc.id)}
        />
      ))}
    </div>
  );
};
